<template>
  <div v-if="showReminder" class="two-factor-ribbon d-flex align-center px-4">
    <v-icon color="error" class="mr-2">mdi-shield-alert</v-icon>
    <span class="subtitle-2 font-weight-bold error--text">
      You have {{ remainingDays }} days left to enable Two-Factor Authentication
      for enhanced security.
    </span>
    <v-spacer />
    <v-btn
      color="indigo darken-3"
      small
      class="white--text mr-2"
      @click="goToAccount"
    >
      <v-icon left>mdi-shield-lock</v-icon>
      Enable 2FA now
    </v-btn>
    <v-btn icon small aria-label="Dismiss" @click="dismissReminder">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router/composables";

export default {
  name: "TwoFactorRibbon",
  props: {
    twoFactorRequired: {
      type: Boolean,
      default: false,
    },
    skipTwoFactorUntil: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const $router = useRouter();
    const showReminder = ref(false);

    const skipTwoFactorDate = props.skipTwoFactorUntil
      ? new Date(props.skipTwoFactorUntil)
      : null;

    const remainingDays = computed(() => {
      if (!skipTwoFactorDate) return 0;

      const currentDate = new Date();
      const timeDiff = skipTwoFactorDate.getTime() - currentDate.getTime();
      const daysRemaining = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return Math.max(0, daysRemaining);
    });

    const is2faDismissed = () => {
      return sessionStorage.getItem("2fa_reminder_dismissed") === "true";
    };

    onMounted(() => {
      checkTwoFactorStatus();
    });

    const checkTwoFactorStatus = () => {
      if (
        !props.twoFactorRequired &&
        !is2faDismissed() &&
        skipTwoFactorDate &&
        remainingDays.value > 0
      ) {
        showReminder.value = true;
      } else {
        showReminder.value = false;
      }
    };

    const dismissReminder = () => {
      showReminder.value = false;
      sessionStorage.setItem("2fa_reminder_dismissed", "true");
    };

    const goToAccount = () => {
      $router.push("/account");
    };

    return {
      showReminder,
      remainingDays,
      dismissReminder,
      goToAccount,
    };
  },
};
</script>

<style scoped>
.two-factor-ribbon {
  /* Full-width advisory band at the top of the content column, with a colored
     left accent. Sticks just below the fixed app bar so it stays visible while
     the content scrolls (the sidebar is unaffected — the band lives in v-main).
     Background is opaque so scrolled content doesn't show through when stuck. */
  position: sticky;
  top: 64px;
  z-index: 4;
  width: 100%;
  min-height: 48px;
  background-color: #fff4f1;
  border-left: 4px solid #ff5533;
}
.theme--dark .two-factor-ribbon {
  background-color: #33262a;
}
/* Material app-bar is 56px tall below the mobile breakpoint. */
@media (max-width: 599px) {
  .two-factor-ribbon {
    top: 56px;
  }
}
</style>
